import React from 'react'

import { ContractDocument } from '../../types'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

import { ContractDoc } from '../../../../types'

type Props = {
    contractGuid: string | undefined
    index: number
    theme: string
    contractConfirmingDoc: ContractDoc
    contractAction: boolean
    onClickEdit: (index_row: number) => void
    onDeleteRow: (index_row: number) => void
}

const ContractConfirmingDocsTableRow: React.FC<Props> = (props) => {
    return (
        <div className="flex flex-col">
            {/* строка оплаты */}
            <div
                className={
                    props.contractAction
                        ? 'plan-position-table-row flex flex-row gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]'
                        : 'plan-position-table-row'
                }
            >
                <div className="flex w-[40px] min-h-[40px] items-center justify-center text-center ">
                    {props.index + 1}
                </div>
                <div className="flex w-[120px] items-center justify-center text-center ">
                    {props.contractConfirmingDoc.doc_num
                        ? props.contractConfirmingDoc.doc_num
                        : '-'}
                </div>
                <div className="flex flex-1 w-full items-center justify-center text-left">
                    {props.contractConfirmingDoc.confirming_doc_code_title
                        ? props.contractConfirmingDoc.confirming_doc_code_title
                        : '-'}
                </div>
                <div className="flex w-[220px] text-left items-center justify-center">
                    {props.contractConfirmingDoc.protocol_name
                        ? props.contractConfirmingDoc.protocol_name
                        : '-'}
                </div>
                <div className="flex flex-row w-[95px] text-left items-center justify-center">
                    {props.contractConfirmingDoc.doc_date
                        ?.split('-')
                        .reverse()
                        .join('-')
                        .replace(/[\-]/g, '.')}
                </div>
                <div className="flex w-8 text-right items-center justify-center"></div>
                {props.contractAction ? (
                    <>
                        <div className="flex w-8 text-right items-center justify-center"></div>
                        <div className="flex w-8 text-right items-center justify-center"></div>
                    </>
                ) : (
                    <>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Редактировать">
                                <button
                                    onClick={() =>
                                        props.onClickEdit(props.index ?? '')
                                    }
                                    className="w-6 h-6 grid rounded-full items-center justify-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="edit-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Удалить">
                                <button
                                    onClick={() =>
                                        props.onDeleteRow(props.index)
                                    }
                                    className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701f1f]"
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="trash-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default ContractConfirmingDocsTableRow
